module.exports = __webpack_public_path__ + "assets/images/f21b838ba42d2628469ad4a3a1649b4e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/portfolio/reserve-web/reserve-web-3.jpg
// module id = 793
// module chunks = 0